(function () {
  'use strict';

  // O bloco pode aparecer várias vezes na página; o asset é injetado uma vez por bloco.
  if (window.__avaliacoesCarouselLoaded) return;
  window.__avaliacoesCarouselLoaded = true;

  var SELECTOR = '[data-avaliacoes-swiper]';
  var instances = new WeakMap();

  function parseConfig(el) {
    try {
      return JSON.parse(el.getAttribute('data-swiper-config') || '{}');
    } catch (error) {
      return {};
    }
  }

  function breakpoint(config, key, fallbackSlides) {
    var value = config[key] || {};
    return {
      slidesPerView: value.slidesPerView || fallbackSlides,
      spaceBetween: typeof value.spaceBetween === 'number' ? value.spaceBetween : 16,
    };
  }

  function init(el) {
    if (!window.Swiper || instances.has(el)) return;

    var config = parseConfig(el);
    var root = el.closest('.avaliacoes-carousel') || el.parentElement;
    var mobile = breakpoint(config, 'mobile', 1.1);

    var options = {
      slidesPerView: mobile.slidesPerView,
      spaceBetween: mobile.spaceBetween,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      speed: config.speed || 500,
      loop: !!config.loop,
      a11y: {
        prevSlideMessage: 'Avaliação anterior',
        nextSlideMessage: 'Próxima avaliação',
      },
      breakpoints: {
        750: breakpoint(config, 'tablet', 2.5),
        1025: breakpoint(config, 'desktop', 4),
      },
    };

    if (config.freeMode) {
      options.freeMode = { enabled: true, sticky: false };
    }

    if (config.autoplay) {
      options.autoplay = {
        delay: config.autoplayDelay || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    if (config.navigation && root) {
      options.navigation = {
        prevEl: root.querySelector('[data-swiper-prev]'),
        nextEl: root.querySelector('[data-swiper-next]'),
        disabledClass: 'swiper-button-disabled',
      };
    }

    if (config.pagination && root) {
      options.pagination = {
        el: root.querySelector('[data-swiper-pagination]'),
        clickable: true,
      };
    }

    instances.set(el, new window.Swiper(el, options));
  }

  function destroy(el) {
    var instance = instances.get(el);
    if (!instance) return;
    instance.destroy(true, true);
    instances.delete(el);
  }

  function each(scope, callback) {
    var node = scope && scope.querySelectorAll ? scope : document;
    if (node.matches && node.matches(SELECTOR)) callback(node);
    node.querySelectorAll(SELECTOR).forEach(callback);
  }

  function initAll(scope) {
    each(scope, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    each(event.target, destroy);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('.swiper-slide');
    if (!slide) return;

    var container = slide.closest(SELECTOR);
    if (!container) return;

    init(container);
    var instance = instances.get(container);
    if (!instance) return;

    var index = Array.prototype.indexOf.call(
      container.querySelectorAll('.swiper-wrapper > .swiper-slide'),
      slide
    );
    if (index < 0) return;

    if (instance.params.loop && typeof instance.slideToLoop === 'function') {
      instance.slideToLoop(index);
    } else {
      instance.slideTo(index);
    }
  });
})();
